import React from 'react';
import { Mail, Facebook, Instagram, Linkedin } from 'lucide-react';
import { bookData } from '../../data/mock';

const socialNetworks = [
  {
    name: 'Facebook',
    icon: Facebook,
    buildUrl: (handle) => `https://www.facebook.com/search/top?q=${encodeURIComponent(handle)}`,
    handle: bookData.contact.social.facebook,
  },
  {
    name: 'Instagram',
    icon: Instagram,
    buildUrl: (handle) => `https://www.instagram.com/explore/search/keyword/?q=${encodeURIComponent(handle)}`,
    handle: bookData.contact.social.instagram,
  },
  {
    name: 'LinkedIn',
    icon: Linkedin,
    buildUrl: (handle) => `https://www.linkedin.com/search/results/people/?keywords=${encodeURIComponent(handle)}`,
    handle: bookData.contact.social.linkedin,
  },
];

export const ContactInfo = () => (
  <div className="text-center mb-16">
    <h2 className="heading-1 mb-6 text-brand-primary">Contatti</h2>
    <div className="w-24 h-1 bg-brand-primary mx-auto mb-8"></div>
    <p className="body-medium text-text-secondary mb-6">
      Hai domande sul libro? Scrivimi, sarò felice di risponderti
    </p>

    <div className="flex flex-col items-center gap-4 mb-6">
      <div className="flex items-center gap-2 text-brand-primary">
        <Mail className="w-5 h-5" />
        <a
          href={`mailto:${bookData.contact.email}`}
          className="body-medium font-semibold hover:underline"
        >
          {bookData.contact.email}
        </a>
      </div>

      <div className="flex items-center gap-6 mt-2">
        {socialNetworks.map(({ name, icon: Icon, buildUrl, handle }) => (
          <a
            key={name}
            href={buildUrl(handle)}
            target="_blank"
            rel="noopener noreferrer"
            className="flex items-center gap-2 text-text-secondary hover:text-brand-primary transition-colors"
            title={name}
          >
            <Icon className="w-6 h-6" />
            <span className="body-small">{name}</span>
          </a>
        ))}
      </div>
    </div>
  </div>
);
